/* src/shared/ui/Card/Card.module.css */
.card {
  background-color: var(--surface-bg-primary);
  border: 1px solid var(--surface-border-subtle);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-subtle);
}

.header {
  padding: var(--spacing-6);
  border-bottom: 1px solid var(--surface-border-subtle);
}

.title {
  margin: 0;
  font-size: var(--text-2xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.description {
  margin: var(--spacing-2) 0 0;
  font-size: var(--text-md);
  color: var(--text-secondary);
}

.content {
  padding: var(--spacing-6);
}

.footer {
  padding: var(--spacing-4) var(--spacing-6);
  background-color: var(--surface-bg-secondary);
  border-top: 1px solid var(--surface-border-subtle);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-4);
}
